module.exports = __webpack_public_path__ + "img/home-banner.6fa7e398.webp";